import request from '@/utils/request.js'

//是否弹出验证码
export const getNeed = (query) => {
  return request({
    url: '/api/standard/captcha/need',
    method: 'get',
    params: query,
  })
}

//获取验证码
export const getAuthCode = (query) => {
  return request({
    url: '/api/standard/captcha/get',
    method: 'get',
    params: query,
  })
}

//校验验证码
export const checkCode = (data) => {
  return request({
    url: '/api/standard/captcha/verify',
    method: 'post',
    data,
  })
}

//执行人脸任务
export const runFaceTask = (data) => {
  return request({
    url: '/api/standard/face/v1/detect',
    method: 'post',
    headers: {
      'Content-type': 'multipart/form-data',
    },
    data,
  })
}

//获取人脸对比图片
export const getImages = (data) => {
  return request({
    url: '/api/standard/algorithm/demo/images',
    method: 'post',
    data,
  })
}

//通用文字
export const commonOcr = (data) => {
  return request({
    url: '/api/standard/ocr/v1/recognize',
    method: 'post',
    data,
  })
}

//宠物对比
export const petCompare = (data) => {
  return request({
    url: '/api/standard/image/v1/recognize',
    method: 'post',
    data,
  })
}

//人体检测
export const bodyRecognition = (data) => {
  return request({
    url: '/api/standard/body/v1/recognize',
    method: 'post',
    data,
  })
}

// img 标签不能携带认证头，通过统一请求客户端下载识别结果图片。
export const getRecognitionImage = (filename, algorithmId, signal) => {
  return request({
    url: '/api/standard/body/v1/recognize',
    method: 'get',
    params: {
      filename,
      tempid: Math.random(),
      algorithm_id: algorithmId,
    },
    responseType: 'blob',
    signal,
  })
}
